import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { MessageCircle, AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { siteConfig } from '@/config/site';

export function MountAlertModal({ isOpen, onClose }) {
  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="w-[80%] max-w-[500px] max-h-[85vh] overflow-y-auto">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-xl">
            <MessageCircle className="h-6 w-6 text-primary" />
            Pembelian Mount - Proses Manual
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-4 pt-2">
              <Alert className="border-amber-500/50 bg-amber-500/10">
                <AlertTriangle className="h-5 w-5 text-amber-500" />
                <AlertDescription className="text-sm ml-2 text-foreground">
                  <strong className="font-semibold">PEMBERIANNYA MASIH MANUAL</strong>
                  <br />
                  Untuk pembelian mount, benefit akan diberikan secara manual oleh staff setelah pembayaran berhasil.
                </AlertDescription>
              </Alert>

              <div className="space-y-3 p-4 rounded-lg border border-border bg-card">
                <h4 className="font-semibold text-sm text-foreground">Cara Pembelian Mount:</h4>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-0.5">1.</span>
                    <span>Lakukan pembayaran melalui QRIS yang akan ditampilkan</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-0.5">2.</span>
                    <span>Simpan bukti struk pembayaran dengan baik</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-0.5">3.</span>
                    <span><strong className="text-foreground">Open ticket di Discord server</strong> dengan menyertakan Order ID</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary mt-0.5">4.</span>
                    <span>Staff akan memproses dan memberikan mount ke akun kamu</span>
                  </li>
                </ul>
              </div>

              <div className="p-3 rounded-lg bg-blue-500/10 border border-blue-500/30">
                <p className="text-xs text-blue-700 dark:text-blue-500 text-center">
                  💬 Join Discord server kami: <strong>{siteConfig.links.discord}</strong>
                </p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction 
            onClick={onClose}
            className="w-full sm:w-auto"
          >
            Saya Mengerti
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
